var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3923 6.57744L12 2.88685C11.3812 2.52958 10.6188 2.52958 9.99997 2.88685L3.60767 6.57744C2.98886 6.93471 2.60767 7.59496 2.60767 8.30949V15.6907C2.60767 16.4052 2.98886 17.0655 3.60767 17.4227L9.99997 21.1133C10.6188 21.4706 11.3812 21.4706 12 21.1133L18.3923 17.4227C19.0111 17.0655 19.3923 16.4052 19.3923 15.6907V8.3095C19.3923 7.59496 19.0111 6.93471 18.3923 6.57744ZM13 1.1548C11.7624 0.440264 10.2376 0.440264 8.99997 1.15479L2.60767 4.84539C1.37006 5.55993 0.607666 6.88043 0.607666 8.30949V15.6907C0.607666 17.1198 1.37006 18.4403 2.60767 19.1548L8.99997 22.8454C10.2376 23.5599 11.7624 23.5599 13 22.8454L19.3923 19.1548C20.6299 18.4403 21.3923 17.1198 21.3923 15.6907V8.3095C21.3923 6.88043 20.6299 5.55993 19.3923 4.84539L13 1.1548Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteel);
export default __webpack_public_path__ + "static/media/steel.e82e6d3d26b972e8752b0ae8e8349e86.svg";
export { ForwardRef as ReactComponent };